import { Link } from 'react-router-dom';
import { useTheme } from '@context/ThemeContext';
import { LogoMarkSvg } from './LogoMarkSvg';

const Logo = ({ size = 'md', showText = true, darkSurroundings = false, className = '', to }) => {
  const { dark } = useTheme();

  const sizes = {
    sm: { box: 'h-9 w-9', text: 'text-lg' },
    md: { box: 'h-11 w-11', text: 'text-xl' },
    lg: { box: 'h-12 w-12', text: 'text-2xl' },
    xl: { box: 'h-14 w-14', text: 'text-3xl' },
    hero: { box: 'h-24 w-24 sm:h-28 sm:w-28', text: 'text-4xl sm:text-5xl' },
  };

  const s = sizes[size] || sizes.md;
  const variant = darkSurroundings ? 'light' : dark ? 'dark' : 'light';

  const markClass = `flex min-w-0 items-center gap-2.5 rounded-xl outline-none transition-opacity hover:opacity-90 active:opacity-80 focus-visible:ring-2 focus-visible:ring-brand-500/40 focus-visible:ring-offset-2 focus-visible:ring-offset-white dark:focus-visible:ring-offset-surface-950 ${className}`;

  const mark = (
    <>
      <div className={`${s.box} shrink-0 flex items-center justify-center overflow-hidden`}>
        <LogoMarkSvg
          variant={variant}
          className="h-full w-full object-contain [object-position:center_58%]"
        />
      </div>
      {showText && (
        <span className={`font-extrabold tracking-tight leading-none ${s.text}`}>
          {darkSurroundings ? (
            <>
              <span className="text-white">Yaar</span>
              <span className="bg-gradient-to-r from-cyan-200 via-white to-violet-200 bg-clip-text text-transparent">vi</span>
            </>
          ) : (
            <>
              <span className="text-surface-900 dark:text-white">Yaar</span>
              <span className="gradient-text">vi</span>
            </>
          )}
        </span>
      )}
    </>
  );

  if (to) {
    return (
      <Link to={to} className={markClass} aria-label="Yaarvi home">
        {mark}
      </Link>
    );
  }

  return <div className={`flex items-center gap-2.5 ${className}`}>{mark}</div>;
};

export default Logo;
